<fr-table [config]="tableConfig" [data]="sitreps" Id="sitreps-table">
  <div above-table-body-space>
    <app-loading-spinner *ngIf="!sitreps"></app-loading-spinner>
  </div>
</fr-table>